import GradientContainer from "@app/components/gradient/gradient-container";
import { useThemeContext } from "@app/contexts/theme-context";
import Image from "next/image";

const MobileHeroBanner = () => {
  const { isTablet } = useThemeContext();

  return (
    <div className="flex justify-center items-center">
      {isTablet ?
        <Image
          src="/images/industries/industries-hero.png"
          alt="hero-mobile"
          width={1023}
          height={512}
        /> : (
          <div>
            <div className="hidden xs:block sm-3:hidden">
              <Image
                src="/images/industries/hero-mobile.png"
                alt="hero-mobile"
                width={768}
                height={832}
              />
            </div>
            <div className="hidden sm-3:block md:hidden">
              <Image
                src="/images/industries/industries-hero.png"
                alt="hero-mobile"
                width={768}
                height={370}
              />
            </div>
            <div className="xs:hidden">
              <Image
                src="/images/industries/hero-mobile.png"
                alt="hero-mobile"
                width={540}
                height={680}
              />
            </div>

          </div>
        )}
      <div className="absolute md:rounded-2xl bg-black bg-opacity-70 p-4 md:w-[80%] py-6 flex items-center justify-center">
        <div className="flex flex-col space-y-3 justify-center items-center text-center">
          <div className="flex flex-col space-y-2 xs:space-y-0 xs:flex-row xs:space-x-4 justify-center">
            <GradientContainer overrideClassName="rounded-xl text-light px-2 py-px">
              Expertise
            </GradientContainer>
            <GradientContainer overrideClassName="rounded-xl text-light px-2 py-px">
              Reliability
            </GradientContainer>
            <GradientContainer overrideClassName="rounded-xl text-light px-2 py-px">
              Innovation
            </GradientContainer>
          </div>
          <h1 className="mobile-h2 2xs:mobile-h1 text-light">
            Industries
          </h1>
          <div className="text-light text-sm 2xs:text-base flex flex-col space-y-5 px-2">
            <div>
              <p>
                We represent a diverse client base, managing all waste and recycling categories.
                Each industry represents its own unique facility, waste, and recycling requirements.
              </p>
            </div>
            <p className="hidden xs:block">
              SimpleWaste provides the expertise, innovation, and reliability to facilitate every project.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default MobileHeroBanner;